var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAViator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 85.04 25.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #11799a;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.13,3.01c0,1.66,1.35,3.01,3.01,3.01h3.01v-3.01c0-1.66-1.35-3.01-3.01-3.01s-3.01,1.35-3.01,3.01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -312.6,
    y1: 393.99,
    x2: -311.78,
    y2: 393.99,
    gradientTransform: "translate(2902.29 -2279.94) rotate(-90) scale(7.31 -7.31)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f58023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faa638"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.88,22.05c-2.45,0-4.11-2.05-4.11-5.22s1.89-5.15,4.17-5.15c2.77,0,4.11,2.54,4.11,5.12,0,3.68-2.02,5.25-4.17,5.25M43.81,21.66c-.46,0-.72-.26-.72-.72v-12.49h-4.14v.72c0,.56.03.98.03.98h-.07s-1.17-2.02-4.79-2.02c-4.4,0-7.56,3.42-7.56,8.7s2.9,8.71,7.4,8.71c3.82,0,5.18-2.71,5.18-2.71h.07v.62c0,.98.55,1.7,2.05,1.7h3.81v-3.49h-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1.28,12.58c-.16-.43-.46-.59-.92-.59h-.36v-3.53h2.39c1.38,0,2.03.43,2.45,1.57l3.14,8.77c.36.98.62,2.39.62,2.39h.07s.26-1.41.59-2.39l3.14-8.77c.42-1.15,1.11-1.57,2.45-1.57h2.22v3.53h-.39c-.46,0-.75.16-.92.59l-4.78,12.57h-4.94L1.28,12.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.29,12.71c0-.49-.26-.72-.72-.72h-1.31v-3.53h3.96c1.54,0,2.19.69,2.19,2.23v10.24c0,.46.26.72.72.72h1.31v3.5h-3.96c-1.54,0-2.19-.66-2.19-2.23v-10.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.75,11.76h-2.16v-3.31h2.26V3.9h4.06v4.55h3.8v3.31h-3.8v6.74c0,2.75,2.16,3.14,3.31,3.14.46,0,.75-.07.75-.07v3.63s-.52.1-1.28.1c-2.32,0-6.94-.69-6.94-6.29v-7.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.03,22c2.72,0,4.97-2.1,4.97-5.2s-2.26-5.2-4.97-5.2-4.94,2.13-4.94,5.2,2.26,5.2,4.94,5.2M64.03,8.06c5.1,0,9.16,3.63,9.16,8.74s-4.06,8.74-9.16,8.74-9.13-3.6-9.13-8.74,4.06-8.74,9.13-8.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.99,12.71c0-.49-.26-.72-.72-.72h-1.31v-3.53h3.8c1.47,0,2.22.62,2.22,2.03v.98c0,.62-.07,1.05-.07,1.05h.07c.75-2.39,2.75-4.29,5.3-4.29.36,0,.75.06.75.06v4.09s-.43-.07-1.02-.07c-1.77,0-3.8,1.02-4.55,3.51-.23.82-.36,1.73-.36,2.71v6.61h-4.12v-12.44Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.13,
    width: 6.01,
    height: 6.01
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAViator);
export default __webpack_public_path__ + "static/media/A-Viator.8ef57cef9cbd7730698a2b078662bfde.svg";
export { ForwardRef as ReactComponent };